import SideMenu from "../core/side-menu";
import "./index.scss";
import { useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/Menu";
import { IconButton, styled } from "@mui/material";
import { BellCorpStudioLogoContainer } from "../packages/common-utilities/Bellcorp-Studio-Logo";
import IntranetHeader from "../core/header";
import MainIntranetHeader from "../packages/common-utilities/core/main-intranet-header";

const MainContainer = ({ children }) => {
  const [showSideMenu, changeviewSettingsForSideMenu] = useState(true);
  const [open, setOpen] = useState(window.innerWidth > 480);
  const MyMenuIcon = styled(open ? MenuOpenIcon : MenuIcon)({
    color: "white",
  });

  return (
    <>
      <div className="main-container">
        <div className="main-right-container">
          <MainIntranetHeader />
          <div className="content-div">
            <div>{children}</div>
            <BellCorpStudioLogoContainer />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainContainer;
